/**
 * Verifies the OTP sent to a user's email during the "forgot password" process.
 *
 * Sends the OTP and email to the backend for validation.
 *
 * Endpoint: POST `/auth/forget/verify-otp`
 *
 * @async
 * @function VerifyOtpForForget
 * @param {string} email - The email address the OTP was sent to.
 * @param {string|number} otp - The OTP code entered by the user.
 * @returns {Promise<{
 *   data: any,         // Response data or message from the server
 *   error: boolean     // Whether the verification failed
 * }>}
 *
 * @example
 * const result = await VerifyOtpForForget("user@example.com", "123456");
 * if (!result.error) {
 *   console.log("OTP verified:", result.data);
 * } else {
 *   console.error("OTP verification failed:", result.data);
 * }
 */

const VerifyOtpForForget = async (email, otp) => {
  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/auth/forget/verify-otp`;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, otp }),
  };

  try {
    const res = await fetch(url, options);
    const data = await res.json();

    if (res.status === 200) {
      return { data: data, error: false };
    }

    // ✅ Fix: return an object with `data` key for consistency
    return { data: data?.message || "Unable to send OTP", error: true };
  } catch (err) {
    console.error("Network error in VerifyOtpForForget:", err);
    return { data: "Network error", error: true };
  }
};

export default VerifyOtpForForget;
